// @flow
import React from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from '../../../../components/GraphLoader';

const ACCurrentLineChart = ({ redAcCurrent, greenAcCurrent, yellowAcCurrent, otherAcCurrent }) => {
    const loading =
        !redAcCurrent?.length && !greenAcCurrent?.length && !yellowAcCurrent?.length && !otherAcCurrent?.length;

    if (loading) {
        return <GraphLoader />;
    }

    const apexLineChartWithLables = {
        chart: {
            animations: { enabled: false },
            height: 364,
            type: 'line',
            dropShadow: { enabled: true, opacity: 0.1, blur: 7, left: -7, top: 7 },
            toolbar: { show: true, offsetX: 0, offsetY: -30 },
            parentHeightOffset: 0,
        },
        grid: { padding: { left: 0, right: 0 } },
        dataLabels: { enabled: false },
        stroke: { width: [3], curve: 'straight' },
        zoom: { enabled: true },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            showForSingleSeries: true,
            show: true,
        },
        colors: ['#ff0000', '#34cb4a', '#F4D03F', '#F39C12'],
        xaxis: {
            type: 'datetime',
            labels: { format: 'dd MMM yyyy' },
            tooltip: { enabled: false },
            axisBorder: { show: false },
        },
        yaxis: { type: 'value', forceNiceScale: true },
    };

    const apexLineChartWithLablesData = [
        { name: 'AC CURRENT RED', data: redAcCurrent },
        { name: 'AC CURRENT GREEN', data: greenAcCurrent },
        { name: 'AC CURRENT YELLOW', data: yellowAcCurrent },
        { name: 'AC CURRENT OTHER', data: otherAcCurrent },
    ];

    return (
        <Chart
            options={apexLineChartWithLables}
            series={apexLineChartWithLablesData}
            type="line"
            className="apex-charts mt-3"
            height={378}
        />
    );
};

export default ACCurrentLineChart;
